import { UAParser } from "ua-parser-js";
// import { BRANDING } from "design-system/src/constants";

import getDeviceType from "./getDeviceType";
import { getOsPlatform } from "./getOsPlatform";

const DEFAULT_DEVICE_TYPE = "web";
const UNKNOWN_BROWSER = "UNKNOWN";

const OS = {
  ANDROID: "Android",
  IOS: "iOS",
  UNKNOWN: "UNKNOWN",
};

const parser = new UAParser();
const deviceSystem = parser.getResult();

const {
  device: { model = "" } = {},
  device: rawDevice = {},
  browser = {},
  ua,
} = deviceSystem;

const { device, deviceType } = getDeviceType(ua);
const { os, devicecategory } = getOsPlatform(deviceSystem);

const _deviceType = rawDevice?.type || deviceType || DEFAULT_DEVICE_TYPE;

const PlatformService = {
  getPlatformInfo() {
    return {
      // build: BRANDING.WEB_VERSION,
      os,
      model: rawDevice.model || null,
      brand: rawDevice.vendor || null,
      deviceType: _deviceType,
      browser: browser.name
        ? `${browser.name}(${browser.version})`
        : UNKNOWN_BROWSER,
      device,
      deviceName: model.length > 2 ? model : deviceType || DEFAULT_DEVICE_TYPE,
      devicecategory,
    };
  },
};

export default PlatformService;
